import { useOnce } from './useOnce';

export function useOnMount(fn: () => void) {
  return useOnce({ fn });
}
